import {
  AUDIO_TYPE,
  IMAGE_TYPE,
  PDF_TEMPLATE_TYPE,
  PDF_TYPE,
  VIDEO_TYPE,
} from '../../constants/file'

import { AudioPreview } from './AudioPreview'
import { ImagePreview } from './ImagePreview'
import { PdfPreview } from './PdfPreview'
import { PdfTemplatePreview } from './PdfTemplatePreview'
import { VideoPreview } from './VideoPreview'

export const PREVIEW_COMPONENT = {
  [AUDIO_TYPE]: AudioPreview,
  [IMAGE_TYPE]: ImagePreview,
  [PDF_TEMPLATE_TYPE]: PdfTemplatePreview,
  [PDF_TYPE]: PdfPreview,
  [VIDEO_TYPE]: VideoPreview,
}

export const BUTTON_NEXT = 'next'

export const BUTTON_BACK = 'back'

export const FILES_PREVIEW_PDF_PERMANENT_API_PARAMS = {
  ensure_urls_signed: true,
}
